<template>
  <div>
    <main class="page-content">
      <div class="container" v-if="event.name.length > 0">
        <Welcome :attendee="attendee" />
        <ItineraryNotPublished v-if="!itinerary_published" :itinerary_published_at_text="itinerary_published_at_text"/>
        <WhatsHappening :entries="nonBreakEntries" v-if="itinerary_published" />
        <Schedule :entries="entries" />
      </div>
    </main>
  </div>
</template>

<script>
import Vue from 'vue'
import Schedule from './Schedule.vue'
import Welcome from './Welcome.vue'
import Chat from './Chat.vue'
import ItineraryNotPublished from './ItineraryNotPublished.vue'
import WhatsHappening from './WhatsHappening.vue'
import { mapState } from 'vuex'
import _ from 'lodash'

export default {
  name: 'Dashboard',
  components: {
    Schedule,
    Welcome,
    ItineraryNotPublished,
    WhatsHappening
  },
  data (){
    return {
      entries: [],
      refreshTimer: '',
      itinerary_published: null,
      itinerary_published_at_text: '',
      schedule_modified_at: null
    }
  },
  computed: {
    ...mapState(['event', 'attendee', 'chat']),
    nonBreakEntries() {
      return _.filter(this.entries, (entry) => {
        return entry.type != 'break'
      })
    }
  },
  created() {
    let self = this
    if (!localStorage.signedIn) {
      this.$router.replace('/signin')
      return
    }
    this.fetchSchedule().then(this.initializeChat).then(this.initializeFetchDelegateInformation)
    this.refreshTimer = setInterval(this.fetchSchedule, 120000)

    this.$store.state.ablyChannel.subscribe('schedule_modified', ({data}) => {
      if (data.schedule_modified_at != this.schedule_modified_at) {
        self.fetchSchedule()
      }
    });

    this.fetchNotifications()

    this.$store.state.ablyChannel.subscribe('notification', function({data}) {
      self.$store.commit("addNotification", data)
      self.$toast.info(data.text, {
        onClose: () => {
          self.$store.commit("markNotificationsAsRead", [data.id])
        }
      });
    });
  },
  methods: {
    fetchSchedule() {
      return this.$http.secured.get('/attendee_api/v1/schedule')
        .then(response => {
          this.$store.commit("setEvent", response.data.event)
          this.$store.commit("setAttendee", response.data.attendee)
          this.entries = response.data.entries
          this.itinerary_published = response.data.itinerary_published
          this.itinerary_published_at_text = response.data.itinerary_published_at_text
          this.schedule_modified_at = response.data.schedule_modified_at

          document.title = this.event.name
          this.$store.commit("loaded")
         })
        .catch(() => console.log('Something went wrong'))
    },
    fetchDelegateInformation() {
      console.log((this.attendee))
      if (this.attendee?.type != 'supplier') { return }

      return this.$http.secured.get('/attendee_api/v1/delegate_information')
        .then(response => {
          this.$store.commit("setDelegateInformation", response.data)
         })
        .catch(() => console.log('Something went wrong'))
    },
    fetchNotifications() {
      return this.$http.secured.get('/attendee_api/v1/notifications')
        .then(response => {
          this.$store.commit("setNotifications", response.data)
         })
        .catch(() => console.log('Something went wrong'))
    },
    initializeChat() {
      if (!this.attendee.attending_online) { return }

      this.$store.commit("setChat", new (Vue.extend(Chat))({
        propsData: {
          attendee: this.attendee
        }
      }))
    },
    initializeFetchDelegateInformation() {
      if (!this.attendee?.type == 'supplier' || !this.itinerary_published) { return }

      this.fetchDelegateInformation()
      this.refreshDelegateInformationTimer = setInterval(this.fetchDelegateInformation, 120000)
    }
  },
  beforeDestroy () {
    clearInterval(this.refreshTimer)
  }
}
</script>

<style>
</style>
